export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_MEETING = 'SET_MEETING'
export const SET_MEETINGS = 'SET_MEETINGS'
export const UPDATE_MEETING = 'UPDATE_MEETING'
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS'
export const REMOVE_MEETING = 'REMOVE_MEETING'



// WEBPACK FOOTER //
// ./src/store/modules/meetings/mutation-types.js